/**
 * @desc 线下订单可拆包裹列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackage.getBusinessDetachableList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/systemOrderPackage/getBusinessDetachableList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
